const uploadPathMarker = '/uploadFile/';

export const normalizeUploadAssetUrl = (value?: string) => {
  const rawUrl = String(value || '').trim();
  if (!rawUrl) return '';

  try {
    const parsedUrl = new URL(rawUrl, window.location.origin);
    const uploadIndex = parsedUrl.pathname.indexOf(uploadPathMarker);
    if (uploadIndex >= 0) {
      return `${parsedUrl.pathname.slice(uploadIndex)}${parsedUrl.search}${parsedUrl.hash}`;
    }
  } catch {
    // Keep non-URL values unchanged unless they contain a known upload path.
  }

  const uploadIndex = rawUrl.indexOf(uploadPathMarker);
  if (uploadIndex >= 0) return rawUrl.slice(uploadIndex);
  return rawUrl;
};

export const normalizeUploadAssetHtml = (html?: string) => {
  const rawHtml = String(html || '');
  if (!rawHtml || !rawHtml.includes(uploadPathMarker)) return rawHtml;

  const template = document.createElement('template');
  template.innerHTML = rawHtml;
  template.content.querySelectorAll<HTMLImageElement>('img[src]').forEach((image) => {
    image.setAttribute('src', normalizeUploadAssetUrl(image.getAttribute('src') || ''));
  });
  return template.innerHTML;
};
